import { render } from "./ModalLoadMP.vue?vue&type=template&id=4d40b49b"
import script from "./ModalLoadMP.vue?vue&type=script&lang=js"
export * from "./ModalLoadMP.vue?vue&type=script&lang=js"

import "./ModalLoadMP.vue?vue&type=style&index=0&id=4d40b49b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__